import styled, { css } from 'styled-components/macro';

export const LayoutStyles = styled.div<{
  src?: string;
  $bgHeight?: string;
  bgColor: string;
  fullHeight?: boolean;
}>`
  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: left top;
    `};

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      min-height: 100vh;
      display: flex;
      flex-direction: column;
    `};
`;
